import {css} from "@emotion/react";
import React from 'react';
import {Spacing} from "../../../Spacing";
import {Card} from "../../../TabsRoute/components/Card";
import {Typography} from "../../../Typography";
import {recordsLimit} from "../../constants";
import {useAQM} from "../../context";
import {DataDetailsModal} from "./components/DataDetailsModal";
import {DataSvg} from "./components/DataSvg";
import {DetailsIcon} from "./components/DetailsIcon";
import {Table} from "./components/Table";


const minRows = recordsLimit;

export const fillArray = <T, >(arr: T[], value: T, targetLength: number) => {
    while (arr.length < targetLength) {
        arr.push(value);
    }
    return arr;
};

export const DataListCard: React.FC = () => {
    const [dataRows, setDataRows] = React.useState<{
        id: number[],
        exposureDate: (string | null)[],
        concentration: (number | null)[],
    }>({
        id: fillArray([], -1, minRows),
        exposureDate: fillArray([], null, minRows),
        concentration: fillArray([], null, minRows),
    });
    const {data} = useAQM();

    React.useLayoutEffect(() => {
        if (data) {

            setDataRows({
                id: fillArray(data.map(x => x.id), -1, minRows),
                exposureDate: fillArray(data.map(x => x.exposureOn), null, minRows),
                concentration: fillArray(data.map(x => x.concentration), null, minRows),
            });
        }
    }, [data]);

    const [openDetails, setOpenDetails] = React.useState<boolean>(false);

    const [targetDataId, setTargetDataId] = React.useState<number | undefined>();


    return <Card>
        <DataDetailsModal
            dataId={targetDataId}
            open={openDetails}
            onClose={() => {
                setOpenDetails(false);
                setTargetDataId(undefined);
            }}
        />
        <Typography variant={"h3"} leftIcon={<DataSvg/>}>Data List</Typography>
        <Spacing h={3}/>
        <Table fullWidth={true} data={[{
            name: "Exposure Date",
            options: {align: "left"},
            values: dataRows.exposureDate, // Array(rows).fill("01/01/2021"),
        }, {
            name: "Concentration",
            values: dataRows.concentration, // Array(rows).fill("100"),
        }, {
            name: "Details",
            options: {align: "right"},
            values: fillArray(Array(data.length).fill(0).map((_, idx) => <div css={css({
                display: "flex",
                flex: 1,
                alignItems: "center",
                width: 80,
                justifyContent: "center",
            })}><DetailsIcon onClick={() => {
                setTargetDataId(dataRows.id[idx]);
                setOpenDetails(true)
            }}/></div>), null, minRows),
        }]}/>
    </Card>
};